<template>
  <div>
    <edit-customer-modal :customer="selected_company" :origin="'companyPage'" :on-save-callback="fetchData"></edit-customer-modal>
    <div class="row justify-content-between">
      <div class="col-auto d-flex align-items-center">
        <h3 class="mb-0"  style="font-family:Ubuntu, sans-serif;">Companies</h3>
      </div>
      <!-- <div class="col-auto d-flex align-items-center">
        <a href="order" type="button" role="button" class="btn btn-primary">Create Order</a>
      </div> -->
    </div>
    <hr>
<div class="row justify-content-between align-middle">
      <div class="col-md-4">
        <div class="input-group mb-3">
          <input type="text" v-model="pagination.searchparams.search" class="form-control" style="background-color:#fff" placeholder="Search..." @keyup.enter="runSearch" :readonly="loading"/>
      
            <span v-if="!search_params_changed">
              <button v-if="!loading" type="button" class="btn btn-outline-secondary  btn-search" @click="runSearch"><i class="fa fa-search"></i></button>
            
              <button v-else type="button" class="btn btn-outline-secondary btn-search" disabled><i class="fa fa-spinner fa-spin"></i></button>
            </span>
            <span v-else>
              <button type="button" class="btn btn-primary btn-search" @click="search_params_changed = false; runSearch();"><i class="fa fa-search"></i> Apply Updated Filters</button>
            </span> &nbsp &nbsp <button class="btn btn-outline-danger btn-reset pull-right" style="border-radius: 0.375rem;" type="button" role="button" @click="resetSearch">Reset</button>
             
        </div>

      </div>
      <div class="col-md-4 text-center">
        <p class="mt-2 mb-0">Showing <strong>{{ pagination.from | commanumeric }}</strong>-
          <strong>{{ pagination.to | commanumeric }}</strong>
          of <strong>{{ pagination.total | commanumeric }}</strong>
        </p>
  <!--       <ul class="nav justify-content-end" v-if="!loading">
          <li class="nav-item px-1">
            <div class="input-group input-group-sm">
                <span class="input-group-text">Sales Rep</span>
                <select v-model="pagination.searchparams.user" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                  <option v-for="user in pagination.filter_options.users" :key="user.id" v-bind:value="user.id">
                    {{ user.name }}
                  </option>
                </select>
              </div>
          </li>
          <li class="nav-item px-1">
            <div class="input-group input-group-sm">
                <span class="input-group-text">Customer</span>
                <select v-model="pagination.searchparams.contact" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                  <option v-for="contact in pagination.filter_options.contacts" :key="contact.id" v-bind:value="contact.id">
                    {{ contact.company_name }}
                  </option>
                </select>
              </div>
          </li>
          <li class="nav-item px-1">
            <div class="input-group input-group-sm">
                <span class="input-group-text">Status</span>
                <select v-model="pagination.searchparams.sync_status" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                  <option v-for="status in pagination.filter_options.statuses" :key="status.sync_status" v-bind:value="status.sync_status">
                    {{ status.sync_status }}
                  </option>
                </select>
              </div>
          </li>

        </ul> -->
      </div>
       <div class="col-md-4 text-end">
        <button v-if="!show_add_customer" class="btn btn-light text-white" style="background-color:#ff7a59;" @click="show_add_customer = true">Add Hubspot Companies</button>
          
        <div class="input-group"  :class="add_contact_error ? 'mb-1' : 'mb-3'" v-if="show_add_customer">
          <input type="text" class="form-control bg-white" placeholder="Copy and paste associated contact's Hubspot ID" aria-label="Recipient's ID" aria-describedby="hubspotContactId" v-model="hubspot_new_contact">
          <button class="btn btn-light text-white" type="button" id="hubspotContactId" style="background-color:#ff7a59;" aria-describedby="textHelp" @click="addCustomer">Import Hubspot Companies</button>
          <button class="btn btn-outline-secondary" type="button" @click="cancelAddCustomer"><i class="fa fa-times"></i></button>
          
        </div>
        <div class="row" v-if="add_contact_error">
          <div id="textHelp" class="form-row form-text text-danger mb-2">{{ add_contact_error }}</div>
        </div>
        <div class="row" v-if="add_contact_success">
          <div id="textHelp" class="form-row form-text text-success mb-2"> {{ add_contact_success }} </div>
        </div>
        


          <!-- <form class="row g-3" v-if="show_add_customer">
            <div class="col-auto">
              <label for="hubspotContactId" class="form-label">Hubspot CONTACT ID</label>
              <input type="number" class="form-control form-control-sm" id="hubspotContactId" aria-describedby="hubspotContactId" v-model="hubspot_new_contact">
            </div>
            <div class="col-auto">
              <button class="btn btn-light text-white" style="background-color:#ff7a59;" @click="show_add_customer = false">Import</button>
            </div>
          </form> -->
    
      </div>
    </div>
    <div  class="row justify-content-center">
      <div class="col-md-12">
        <div class="card" v-if="pagination.data.length > 0">      
          <table class="table table-hover align-middle" style="display:table">
            <thead class="thead-light">
              <tr>
                
                <th scope="col" style="white-space:nowrap;" class="">Hubspot Links</th>
                <!-- <th scope="col" style="white-space:nowrap;" >Hubspot Company</th> -->
                <th scope="col" style="white-space:nowrap;" >Company</th>
                <th scope="col" style="white-space:nowrap;" >Contact</th>
                <th scope="col" style="white-space:nowrap;" >Email</th>
                <th scope="col" style="white-space:nowrap;max-width:160px" >Phone</th>
                
                <th class="text-center" scope="col" style="white-space:nowrap;" >Recent Deal Amount</th>
                <th class="text-center" scope="col" style="white-space:nowrap;" >Annual Revenue</th>
                <th scope="col" style="white-space:nowrap;" >City</th>
                <th scope="col" style="white-space:nowrap;" class="text-center">State</th>
                <th scope="col" style="white-space:nowrap;min-width:140px;" class="text-center">Actions</th>
                <!-- <th scope="col" style="white-space:nowrap;" >Country</th> -->
   
                
                
                
              </tr> 
            </thead>
            <tbody>
              <tr v-for="company in companies">
               
                <td class="">
                  <a target="_blank" role="button" type="button" class="btn btn-sm btn-light" :href="'https://app.hubspot.com/contacts/21619105/contact/' + company.hubspot_contact_id ">Contact</a>
               
                  <a target="_blank" role="button" type="button" class="btn btn-sm btn-light" :href="'https://app.hubspot.com/contacts/21619105/company/' + company.hubspot_company_id ">Company</a>
                </td>
                <td class="">
                  <span v-if="company.domain"><a :href="'https://' + company.domain" target="_blank">{{ company.company_name }}</a></span>
                  <span v-else>{{ company.company_name }}</span>
                </td>
                <td class="">{{ company.contact_name }}</td>
                <td class="">{{ company.email }}</td>
                <td class="" style="max-width:160px;">{{ company.phone }}</td>
                
                <td class="text-center">{{ company.recent_deal_amount | currency }}</td>
                <td class="text-center">{{ company.annual_revenue | currency }}</td>
                <td class="">{{ company.city }}</td>
                <td class="text-center">{{ company.state }}</td>
                 <td class="text-end" style="min-width:140px;">
                  <a @click="editCustomer(company)" type="button" role="button" class="btn btn-sm btn-light text-secondary border-secondary"><i class="fa fa-pencil"></i></a>
                  <a :href="'/order?contact=' + company.id" type="button" role="button" class="btn btn-sm btn-dark">Create Order</a>
                </td>
                <!-- <td class="">{{ company.country }}</td> -->

                
         
                
              </tr>
            </tbody>

          </table>
          <div class="row justify-content-center">
              <div v-if="pagination.data.length > 0" class="col-md-12 pt-0 pb-3">
                <nav aria-label="Page navigation">
                  <ul class="pagination nav justify-content-center">
                    <li class="page-item" ><a class="page-link" @click="firstPage"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a></li>
                    <li class="page-item" :class="{ disabled: pagination.current_page == 1 }"><a class="page-link" @click="prevPage" >Previous</a></li>
                    <li class="page-item" :class="{ disabled: !pagination.has_more_pages }"><a class="page-link" @click="nextPage">Next</a></li>
                    <li class="page-item"><a class="page-link" @click="lastPage"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a></li>
                  </ul>
                </nav>
              </div>
            </div>

        </div>
        <div v-else class="card">
          <div class="card-body">
            <div class="row justify-content-center">
              No orders matching search criteria found
            </div>
          </div>
        </div>
              <!-- <div class="card" v-for="product in products">

                  <div class="card-body row">
                      <div class="col-md-2">
                        <img style="max-height:100px;" :src="product.image_url" crossorigin="anonymous" />
                      </div>
                      <div class="col-md-5">
                        <h2>{{ product.name }}</h2>
                        <h3>$ {{ product.sale_price }}</h3>
                      </div>
                  </div>
              </div> -->
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
.btn-search {
    border-radius: 0rem .25rem .25rem 0rem;
  }

  .btn-reset {
    border-top-left-radius: 0.375rem;
  }

  .btn-dark {
    font-family: Ubuntu, sans-serif;
    font-style: normal;
    background-color: #000;
  }

</style>

<script>
// import 'qs';
const qs = require('qs');
// import qs from 'qs';

import moment from 'moment'
  export default {
   props:[],
    data() {
      return {
        pagination: {
          "current_page": 1,
          "data": [],
          "first_page_url": null,
          "from": null,
          "last_page": null,
          "last_page_url": null,
          "next_page_url": null,
          "path": null,
          "prev_page_url": null,
          "to": null,
          "total": null,
          "has_more_pages": false,
          "per_page": 10,
          "filters": {
            // 'contacts': [],
            // 'statuses': [],
            // 'users': [],
          },
          "searchparams": {
            "search": "",
            "sortby": "updated_at",
            "order": "desc",
            // "user": "",
            // "contact": "",
            // "sync_status": "",
          },
        },
        data_endpoint: "/api/companies",
        customer_add_endpoint: "/api/contact/",
        search_params_changed: false,
        companies: [],
        selected_company: [],
        loading: false,
        fetched_companies: false,
        hubspot_new_contact: null,
        add_contact_error: null,
        add_contact_success: null,
        show_add_customer: false
      };
    },
    created() {
      // runs when the component is created
      this.fetchData();
    },
    mounted() {
      // runs when the element is injected into the browser
    },
    computed: {

    },
    methods: {
      fetchData(){
        this.fetchCompanies(this.pagination.searchparams);
      },

      fetchCompanies(params, page = 1) {
        this.loading = true;
        params.page = page;
        params.per_page = this.pagination.per_page;
        axios.get(this.data_endpoint, {
                params: params,
                paramsSerializer: function(params) {
                    return qs.stringify(params)
                },

          }).then((res) => {
            this.pagination = res.data;
            this.companies = res.data.data
          }).catch((error) => {
            console.log(error.response.data);
          }).finally(() => {
            this.fetched_companies = true;
            this.loading = false;
            return true;
          });
      },
      addCustomer() {
        this.add_contact_success = null;
        // this.loading = true;
        // params.page = page;
        // params.per_page = this.pagination.per_page;
        axios.get(this.customer_add_endpoint + this.hubspot_new_contact)
          .then((res) => {
            this.add_contact_success = res.data.data
            this.show_add_customer = false;
            this.hubspot_new_contact = null;
            this.add_contact_error = null;
            this.fetchCompanies();
          }).catch((error) => {
            
            this.add_contact_error = error.response.data.message;
            // console.log(error.response.data);
          }).finally(() => {
            this.loading = false;
            return true;
          });
      },
      cancelAddCustomer() {
        this.show_add_customer = false;
        this.hubspot_new_contact = null;
        this.add_contact_success = null;
        this.add_contact_error = null;
      },
      nextPage(){
        this.fetchCompanies(this.pagination.searchparams, this.pagination.current_page + 1);
      },
      prevPage(){
        this.fetchCompanies(this.pagination.searchparams, this.pagination.current_page - 1);
      },
      firstPage(){
        this.fetchCompanies(this.pagination.searchparams, 1);
      },
      lastPage(){
        this.fetchCompanies(this.pagination.searchparams, this.pagination.last_page);
      },
      runSearch() {
        this.fetchCompanies(this.pagination.searchparams);
        this.search_params_changed = false;
      },
      resetSearch() {
        this.pagination.first_page_url = null;
        this.pagination.from = null;
        this.pagination.last_page = null;
        this.pagination.last_page_url = null;
        this.pagination.next_page_url = null;
        this.pagination.path = null;
        this.pagination.prev_page_url = null;
        this.pagination.to = null;
        this.pagination.total = null;
        this.pagination.has_more_pages = false;
        this.pagination.per_page = 10;
        this.pagination.searchparams.search = '';
        this.pagination.searchparams.sortby = 'created_at';
        this.pagination.searchparams.order = 'desc';
        this.pagination.searchparams.contact = '';
        this.pagination.searchparams.sync_status = '';
        this.pagination.searchparams.user = '';
        this.runSearch();
      },
      editCustomer(company) {
        this.selected_company = company;
        setTimeout(this.showEditCustomerModal, 250);
      },
      showEditCustomerModal() {
        Bus.$emit('editCustomerModalShow');
      },

    },
    filters: {
        moment: function (date) {
            // return moment(date).format('MM/DD/YYYY, h:mm a');
            return moment(date).format('MMMM Do, YYYY');
        }
    }
  }

</script>
